import type { SavasKaydi, Taraf } from '@kurultay/savas'

export interface BirimOzeti {
  id: string
  taraf: Taraf
  verilenHasar: number
  alinanHasar: number
  vurusSayisi: number
  isabetsizSayisi: number
  kritikSayisi: number
  oldu: boolean
}

export interface HasarTuruDagilimi {
  fiziksel: number
  ruh: number
}

export interface SavasRaporu {
  kazanan: Taraf | null
  turSayisi: number
  birimler: BirimOzeti[]
  tarafHasari: Record<Taraf, number>
  hasarTuruDagilimi: Record<Taraf, HasarTuruDagilimi>
  isabetsizlikOrani: Record<Taraf, number>
  enCokHasarVeren: string | null
}

function tarafiCikar(birimId: string): Taraf {
  return birimId.startsWith('a-') ? 'a' : 'b'
}

function bosOzet(id: string): BirimOzeti {
  return {
    id, taraf: tarafiCikar(id),
    verilenHasar: 0, alinanHasar: 0,
    vurusSayisi: 0, isabetsizSayisi: 0, kritikSayisi: 0, oldu: false,
  }
}

/**
 * Savaş kaydını okunabilir bir rapora çevirir.
 *
 * Rapor bilgi değil ÖĞRETİM aracıdır: kaybeden oyuncu "neyi yanlış yaptım"
 * sorusunun cevabını burada bulmalı. Bu yüzden hasar türü dağılımı ve
 * isabetsizlik oranı ayrıca hesaplanır — yanlış hasar türü seçmek ve
 * isabetsiz vurmak, kaybetmenin en sık iki sebebidir.
 */
export function raporUret(kayit: SavasKaydi): SavasRaporu {
  const birimler = new Map<string, BirimOzeti>()
  const al = (id: string) => {
    let o = birimler.get(id)
    if (!o) { o = bosOzet(id); birimler.set(id, o) }
    return o
  }

  const tarafHasari: Record<Taraf, number> = { a: 0, b: 0 }
  const dagilim: Record<Taraf, HasarTuruDagilimi> = {
    a: { fiziksel: 0, ruh: 0 },
    b: { fiziksel: 0, ruh: 0 },
  }
  const vurus: Record<Taraf, number> = { a: 0, b: 0 }
  const isabetsiz: Record<Taraf, number> = { a: 0, b: 0 }

  for (const olay of kayit.olaylar) {
    if (olay.tip === 'saldiri') {
      const kaynak = al(olay.kaynakId)
      const hedef = al(olay.hedefId)
      const taraf = kaynak.taraf

      kaynak.vurusSayisi++
      vurus[taraf]++
      if (!olay.isabetEtti) {
        kaynak.isabetsizSayisi++
        isabetsiz[taraf]++
        continue
      }
      if (olay.kritik) kaynak.kritikSayisi++
      kaynak.verilenHasar += olay.hasar
      hedef.alinanHasar += olay.hasar
      tarafHasari[taraf] += olay.hasar
      dagilim[taraf][olay.hasarTuru] += olay.hasar
    } else if (olay.tip === 'olum') {
      al(olay.birimId).oldu = true
    }
  }

  const liste = [...birimler.values()].sort((x, y) => y.verilenHasar - x.verilenHasar)

  return {
    kazanan: kayit.kazanan,
    turSayisi: kayit.turSayisi,
    birimler: liste,
    tarafHasari,
    hasarTuruDagilimi: dagilim,
    isabetsizlikOrani: {
      a: vurus.a > 0 ? isabetsiz.a / vurus.a : 0,
      b: vurus.b > 0 ? isabetsiz.b / vurus.b : 0,
    },
    enCokHasarVeren: liste[0]?.verilenHasar ? liste[0].id : null,
  }
}
